module.exports = __webpack_public_path__ + "media/images/new-form-button-0a73b4c9.gif";